import { PRINT_BLEED_PADDING } from 'constants/printBleed';

const PRINT_BLEED_BOX_SHADOW = '0 0 0 2px var(--vg-colors-red-500)';

const PAGE_TRIM_OVERLAY_SIZE_CSS = (zoom: number) => `calc(100% - ${PRINT_BLEED_PADDING * zoom * 2}px)`;

export { PRINT_BLEED_BOX_SHADOW, PAGE_TRIM_OVERLAY_SIZE_CSS };
